import Snackbar from '@mui/material/Snackbar';
import Alert from '@mui/material/Alert';
import { ToasterSeverity } from '../../types';

interface ToasterProps {
  open: boolean;
  onClose: (event: React.SyntheticEvent | Event, reason?: string) => void;
  severity: ToasterSeverity;
  message: string;
}

export default function Toaster({ open, onClose, severity, message }: ToasterProps) {
  const handleClose = (event: React.SyntheticEvent | Event, reason?: string) => {
    onClose(event, reason);
  };

  return (
    <Snackbar
      open={open}
      autoHideDuration={6000}
      onClose={handleClose}
    >
      <Alert
        severity={severity}
        onClose={handleClose}
        elevation={6}
        variant="filled"
      >
        {message}
      </Alert>
    </Snackbar>
  );
}
